import type { Twt } from "./types.ts";

import { blake2b } from "@exodus/blakejs";

import { base32Encode } from "./utils.ts";
import { HASH_V2_EPOCH } from "./constants.ts";

const dateRegex =
	/^(\d{4})-(\d{2})-(\d{2})([tT ])(\d{2}):(\d{2}):(\d{2})\.?(\d{3})?(?:(?:([+-]\d{2}):?(\d{2}))|Z)?$/;

const formatRFC3339 = (date: string) => {
	const pad = (num: number | string = 0) => `${+num < 10 ? 0 : ""}${+num}`;
	const padYear = (num: number | string = 0) =>
		`${+num < 1000 ? 0 : ""}${+num < 100 ? 0 : ""}${
			+num < 10 ? 0 : ""
		}${+num}`;

	let m = dateRegex.exec(date);

	//if timezone is undefined, it must be Z or nothing (otherwise the group would have captured).
	if (m && m?.[9] === undefined) {
		//Use UTC.
		m[9] = "+00";
	}
	if (m && m?.[10] === undefined) {
		m[10] = "00";
	}

	const offset = `${m?.[9]}:${m?.[10]}`.replace(/[+-]?00:00$/, "Z");

	return [
		padYear(m?.[1]),
		"-",
		pad(m?.[2]),
		"-",
		pad(m?.[3]),
		m?.[4],
		pad(m?.[5]),
		":",
		pad(m?.[6]),
		":",
		pad(m?.[7]),
		//ignore milliseconds (m[8])
		offset,
	].join("");
};

export type HashableTwt = Pick<Twt, "content" | "created" | "url"> &
	Partial<Omit<Twt, "content" | "created" | "url">>;

export default function hashTwt(twt: HashableTwt, version = 0): string {
	const created = formatRFC3339(twt.created);
	const payload = [twt.url, created, twt.content].join("\n");

	const encoded = base32Encode(blake2b(payload, undefined, 32)).toLowerCase();

	const createdDate = new Date(twt.created),
		epochDate = new Date(HASH_V2_EPOCH);

	if (version === 1 || (!version && createdDate < epochDate))
		return encoded.slice(-7);
	return encoded.slice(0, 12);
}
